import React, { useEffect } from 'react';
import BestSeller from '../components/Home/bestSellers/BestSeller';
import NavByCategory from '../components/Home/NavByCategory';
import Products from '../components/Home/products/Products';
import SliderHad from '../components/Home/slider/Slider';

const Home = () => {
    
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <SliderHad/>
            <NavByCategory/>
            <Products/>
            <BestSeller/>
        </>
    );
};

export default Home;